<ion-header class="ion-no-border">
  <ion-toolbar color="primary">

    <ion-title>Modifica gruppo teleconsulto</ion-title>

    <ion-buttons slot="end"> 

      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>

    </ion-buttons>

  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
<ion-grid>
  <ion-row>
    <ion-col size="12">
      <ion-toolbar>

        <ion-text>
          <h5>Info Team: {{name}}</h5>
        </ion-text>
    
        <ion-button [disabled]="participants.length >=  6|| isAddList"  slot="end" (click)="addList()">
          Aggiungi Partecipanti
        <ion-icon slot="start" name="add-outline"></ion-icon>
      </ion-button>
    
      </ion-toolbar>

    </ion-col> 
  </ion-row>

  <ion-row>
  <ion-col size="12">

        <ion-item>
        <ion-label position="stacked">Partecipanti</ion-label>
      </ion-item>
          <ion-list >
            <ng-container *ngFor="let x of participants">
              <ion-item *ngIf="x.trecUserId !== trecUserId">
              
                <ion-label >{{x.surname}} {{x.name}}
                </ion-label>
                <ion-button [disabled]="participants.length<=2" slot="end" (click)="presentAlert(x)">Elimina</ion-button>

              </ion-item>
            </ng-container>

          </ion-list>
</ion-col>


<ion-col size="12" *ngIf="isAddList">
  <ion-item>
    <ion-label position="stacked">Aggiungi Partecipanti</ion-label>
  </ion-item>
              <ion-list>
                <ion-row *ngIf="loading">
                  <ion-col class="c3-flex ion-justify-content-center">
                    <ion-spinner color="secondary"></ion-spinner>
                  </ion-col>
                </ion-row>
                <ion-list-header *ngIf="docList.size === 0">
                  <ion-label>Nessun risultato</ion-label>
                </ion-list-header>
                  <ion-item *ngFor="let doc of docList">
                      <ion-label>{{doc.surname}}  {{doc.name}}</ion-label>
                      <ion-checkbox (ionChange)="updateParticipants($event,doc);"></ion-checkbox>
                  </ion-item>
              </ion-list>
              <ion-label color="danger" *ngIf="maxParticipants">Il numero di partecipanti è maggiore di 5</ion-label>

</ion-col>

</ion-row>
</ion-grid>
</ion-content>

<ion-footer class="ion-padding">
  <ion-row *ngIf="!isAddList">
    <ion-col size="12" style="text-align:right;">
      <ion-button color="primary" (click)="closeModal()">Annulla</ion-button>
      <ion-button [disabled]="isAddList" color="primary" (click)="salva()">Salva</ion-button>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="isAddList">
    <ion-col size="12" style="text-align:right;">
      <ion-button color="primary" (click)="isAddList = false">Annulla</ion-button>
      <ion-button color="primary" [disabled]="maxParticipants" (click)="addParticipants()">Aggiungi</ion-button>
    </ion-col>
  </ion-row>
</ion-footer>